import { render } from "./SelectPositionView.vue?vue&type=template&id=72160418"
import script from "./SelectPositionView.vue?vue&type=script&lang=js"
export * from "./SelectPositionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__